import { useDispatch, useSelector } from "react-redux"
import { getPointedDeviceId } from "../../reducers/devices"
import { useCallback } from "react";
import { postPreviousItem, putItemProgress } from "../../controllers/SpotifyApiController";
import { getPreviousRandomAlbum, getQueuePointer, getRandomModeActive, getRandomRepeatMode } from "../../reducers/randomMode";
import { setFinishedAlbum, setPreviousRandomAlbumAsPointed } from "../../actions/randomModeActions";
import { getItemProgress, isCurrentItemFirstInAlbum } from "../../reducers/playbackState";
import { setPlaybackAction } from "../../actions/disablingProcessesActions";
import { MS_BEFORE_SKIPPING_TO_PREVIOUS } from "../../utils/constants/otherConstants";
import { RANDOM_REPEAT_MODES } from "../../utils/constants/enumConstants";
import { manageTooManyRequestsResponse } from "../../utils/connectionUtils";

export const usePreviousSong = () => {
    const itemProgress = useSelector(getItemProgress);
    const pointedDeviceId = useSelector(getPointedDeviceId);

    const randomModeActive = useSelector(getRandomModeActive);
    const queuePointer = useSelector(getQueuePointer);
    const firstInAlbum = useSelector(isCurrentItemFirstInAlbum);
    const previousRandomAlbum = useSelector(getPreviousRandomAlbum);
    const randomRepeatMode = useSelector(getRandomRepeatMode);

    const dispatch = useDispatch();

    return useCallback(() => {
        const restartCurrentSong = () => {
            putItemProgress(0, pointedDeviceId)
                .then(() => {
                    dispatch(setPlaybackAction(false));
                })
                .catch((error) => {
                    dispatch(setPlaybackAction(false));
                    manageTooManyRequestsResponse(error, dispatch);
                    console.error('Error skipping to previous item: ', error);
                });
        }
    
        const playLastSongOfPreviousAlbum = () => {
            dispatch(setPreviousRandomAlbumAsPointed({trackIndex: previousRandomAlbum.totalTracks - 1}));
        }

        dispatch(setPlaybackAction(true));
        
        if(itemProgress >= MS_BEFORE_SKIPPING_TO_PREVIOUS)
        {
            restartCurrentSong();
            return;
        }
        
        if(randomModeActive)
        {
            dispatch(setFinishedAlbum(false));
            
            // The current song is the first one of the current album and (the current album is not the first one of the queue or the random repeat mode is set to queue) and the random repeat mode is not set to album
            // - It has no sense to skip to the previous album if the current song is not the first one
            // - If the current album is the first one and the random repeat mode is not set to queue, we don't want to jump to the last song of the last album in queue, we want to keep the first song of the first album being played
            // - And if the random repeat mode is set to album, we don't want to exit the current album by skipping a song (it can be done by skipping the album)
            if(firstInAlbum && (queuePointer > 1 || randomRepeatMode === RANDOM_REPEAT_MODES.queue) && randomRepeatMode !== RANDOM_REPEAT_MODES.album)
            {
                // Then, the last song of the previous album of the queue will be played
                playLastSongOfPreviousAlbum();
                return;
            }
        }
                    
        postPreviousItem(pointedDeviceId)
            .then(() => {
                dispatch(setPlaybackAction(false));
            })
            .catch((error) => {
                dispatch(setPlaybackAction(false));
                manageTooManyRequestsResponse(error, dispatch);
                console.error('Error skipping to previous item: ', error);
            });
    }, [pointedDeviceId, randomModeActive, itemProgress, firstInAlbum, previousRandomAlbum, queuePointer, randomRepeatMode, dispatch]);
}